import React from "react";
import { TableContext, useTable } from "@hook";
import { PageTemplate } from "@component";
import { SearchAreaStatisticsContainer } from "@container";

const SearchAreaStatistics = () => {
  const tableState = useTable({
    initial: {
      searchTypes: {
        type: 'SIDO'
      }
    }
  })
  return (
    <TableContext.Provider value={tableState}>
      <PageTemplate>
        <SearchAreaStatisticsContainer />
      </PageTemplate>
    </TableContext.Provider>
  )
}

export default SearchAreaStatistics
